export default {
  menus: {}
};
